import { Reducer } from "redux";

import { GenerateAuthTemplateResponse } from "../models/Api/Document";
import { GenerateAuthTemplateActionDispatchTypes } from "../models/DispatchTypes/Document";
import { GenerateAuthTemplateDispatchTypes } from "../constants/Document";

const initialState: GenerateAuthTemplateResponse = {
  loading: false,
  response: false,
};

const GenerateAuthTemplateReducer: Reducer<
  GenerateAuthTemplateResponse,
  GenerateAuthTemplateActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GenerateAuthTemplateDispatchTypes.POST_GENERATE_AUTH_TEMPLATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GenerateAuthTemplateReducer;
